import React, { Component } from "react";

// Redux
import { connect } from "react-redux";
import { getFunderProfile } from "../../../../redux/actions/funders";

// UI Components
import { Loader, InfoLoader } from "../../../../UI/Loaders/Loaders";
import { LabelledInput } from "../../../../UI/Inputs/Inputs";

class FunderSettings extends Component {
  state = {
    notificationForm: {
      notificationEdit: false,
    },
  };

  editModeHandler = (e) => {
    e.preventDefault();
    let selectedForm = e.currentTarget.dataset["form"];
    this.setState({
      [`${selectedForm}Form`]: {
        ...this.state[`${selectedForm}Form`],
        [`${selectedForm}Edit`]: true,
      },
    });
  };

  cancelUpdateHandler = (e) => {
    e.preventDefault();
    let selectedForm = e.currentTarget.dataset["form"];
    this.setState({
      [`${selectedForm}Form`]: {
        ...this.state[`${selectedForm}Form`],
        [`${selectedForm}Edit`]: false,
      },
    });
  };

  notificationUpdateHandler = (e) => {
    e.preventDefault();
  };

  renderProfile = ({ profile, loading, error }, category) => {
    if (profile === null || loading) {
      return <Loader text="Profile" background="true" />;
    } else if (error) {
      return (
        <div className="mt-40 tfx-user-form-wrapper box-effect full-border white-bg animated fadeInRight">
          <InfoLoader
            text="There was an issue fetching your transactions."
            subText="Kindly reload the page."
          />
        </div>
      );
    } else if (profile) {
      const {
        email,
        first_name,
        last_name,
        phone,
        user_type,
        available_balance,
        date_joined,
        earning_balance,
        total_balance,
      } = profile;

      if (category === "profile") {
        return (
          <div id="adv-aggregator">
            <LabelledInput
              label="Full Name"
              inputValue={`${first_name} ${last_name}`}
              icon="fas fa-user-circle"
            />
            <LabelledInput
              label="Email"
              inputValue={email}
              icon="fas fa-envelope"
            />
            <LabelledInput
              label="Phone"
              inputValue={phone}
              icon="fas fa-phone"
            />
            <LabelledInput
              label="Role"
              inputValue={user_type}
              icon="fas fa-user-tag"
            />
          </div>
        );
      } else {
        return (
          <div id="adv-aggregator">
            <LabelledInput
              label="Earning"
              inputValue={earning_balance}
              icon="fas fa-coins"
            />
            <LabelledInput
              label="Avaliable Balance"
              inputValue={available_balance}
              icon="fas fa-wallet"
            />
            <LabelledInput
              label="Total Balance"
              inputValue={total_balance}
              icon="fas fa-coins"
            />
            <LabelledInput
              label="Date Joined"
              inputValue={date_joined}
              icon="fas fa-sign-in-alt"
            />
          </div>
        );
      }
    }
  };

  // Life Cycle Hooks
  componentDidMount() {
    this.props.getFunderProfile();
  }

  render() {
    const { notificationEdit } = this.state.notificationForm;
    const { funderProfile } = this.props;
    //JSX Template
    return (
      <div>
        <div className="row clearfix mt-30 grid__padding">
          {/*Profile Setings*/}
          <div className="col-lg-4 col-md-6 col-sm-12">
            <div className="card">
              <div className="body text-center">
                <h3 className="m-t-0">
                  <i className="adv-icon fas fa-user-circle" /> Profile
                </h3>
                {this.renderProfile(funderProfile, "profile")}
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6 col-sm-12">
            <div className="card">
              <div className="body text-center">
                <h3 className="m-t-0">
                  <i className="adv-icon fas fa-chart-pie" />
                  &nbsp; Investment
                </h3>
                {this.renderProfile(funderProfile, "investment")}
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6 col-sm-12">
            <div className="card">
              <div className="body text-center">
                <h3 className="m-t-0">
                  <i className="adv-icon fas fa-bell" /> Notifications
                </h3>
                <p className="settings-block text-muted">
                  I want to receive notifications{" "}
                </p>
                <div className="grid__full settings-block">
                  <div className="form-group grid__full">
                    <div className="glass input-group">
                      <div className="login-session">
                        <label
                          htmlFor="loginSession"
                          className="adv-check form-component"
                        >
                          <input
                            id="loginSession"
                            type="checkbox"
                            className="has-value"
                          />
                          <i className="primary" />
                          on top performing loans.
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="form-group grid__full">
                    <div className="glass input-group">
                      <div className="login-session">
                        <label
                          htmlFor="loginSession"
                          className="adv-check form-component"
                        >
                          <input
                            id="loginSession"
                            type="checkbox"
                            className="has-value"
                          />
                          <i className="primary" />
                          when monthly report has been generated
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="form-group grid__full">
                    <div className="glass input-group">
                      <div className="login-session">
                        <label
                          htmlFor="loginSession"
                          className="adv-check form-component"
                        >
                          <input
                            id="loginSession"
                            type="checkbox"
                            className="has-value"
                          />
                          <i className="primary" /> when payment plan has been
                          completed.
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="form-group grid__full">
                    <div className="glass input-group">
                      <div className="login-session">
                        <label
                          htmlFor="loginSession"
                          className="adv-check form-component"
                        >
                          <input
                            id="loginSession"
                            type="checkbox"
                            className="has-value"
                          />
                          <i className="primary" /> When there are new offers
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="grid__full">
                  {notificationEdit ? (
                    <div className="Form__action-buttons">
                      <button
                        type="button"
                        className="btn zoom-element login-btn m-r-1"
                        data-form="notification"
                        onClick={this.cancelUpdateHandler}
                      >
                        <i className="fas fa-close" />
                        &nbsp; Cancel
                      </button>
                      <button
                        type="button"
                        className="btn zoom-element login-btn m-l-1"
                        onClick={(e) => {
                          this.notificationUpdateHandler(e);
                        }}
                      >
                        <i className="fas fa-save" />
                        &nbsp; Save
                      </button>
                    </div>
                  ) : (
                    <button
                      type="submit"
                      className="zoom-element btn login-btn"
                      data-form="notification"
                      onClick={(e) => {
                        this.editModeHandler(e);
                      }}
                    >
                      <i className="fas fa-user-circle" />
                      &nbsp; Edit
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ authReducer, fundersReducer }) => {
  const { isAuthenticated, loggedInUser } = authReducer;
  const { funderProfile } = fundersReducer;

  return {
    isAuthenticated,
    loggedInUser,
    funderProfile,
  };
};

export default connect(mapStateToProps, { getFunderProfile })(FunderSettings);
